import api from "@/lib/api";

// GET ALL REVIEWS
export const getAllReviewList = async () => {
  const res = await api.post("/reviews/getAllReviewList");
  return res.data;
};

// GET BY STATUS
export const getReviewListByStatus = async (status) => {
  const res = await api.post("/reviews/getReviewListByStatus", { status });
  return res.data;
};

// PENDING / STATUS COUNT
export const getReviewCount = async (status) => {
  const res = await api.post("/reviews/getReviewCount", status ? { status } : {});
  return res.data;
};

// DASHBOARD STATS
export const getReviewDashboard = async () => {
  const res = await api.get("/reviews/getReviewDashboard");
  return res.data;
};

// GET SINGLE REVIEW
export const getReview = async (id) => {
  const res = await api.post("/reviews/getReview", { id });
  return res.data;
};

// MODERATE (approve / reject / flagged)
export const moderateReview = async ({ id, status, moderator_note = "" }) => {
  const res = await api.post("/reviews/moderate", {
    id,
    status,
    moderator_note,
  });
  return res.data;
};

// DELETE
export const deleteReview = async (id) => {
  const res = await api.post("/reviews/delete", { id });
  return res.data;
};

// CREATE (multipart)
export const createReview = async ({
  firm_id,
  challenge_id,
  headline,
  description,
  ratings,
  proof_of_purchase,
}) => {
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("challenge_id", challenge_id);
  formData.append("headline", headline || "");
  formData.append("description", description || "");
  formData.append("ratings", typeof ratings === "string" ? ratings : JSON.stringify(ratings || []));
  if (proof_of_purchase) {
    formData.append("proof_of_purchase", proof_of_purchase);
  }
  const res = await api.post("/reviews/create", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// EVIDENCE
export const getReviewEvidence = async (filename) => {
  const res = await api.post("/reviews/getReviewEvidence", { filename });
  return res.data;
};